import { getActiveTheme } from './themes';

const theme = getActiveTheme();
const c = theme.colors;

export class Colors {
  // === BACKGROUNDS ===
  static bg = c.bg;
  static bgElevated = c.bgElevated;
  static bgSurface = c.bgSurface;
  static bgInput = c.bgInput;
  static inputSelectionBg = c.inputSelectionBg;
  static inputSelectionText = c.inputSelectionText;
  static bgCode = c.bgCode;
  static bgOverlay = c.bgOverlay;

  // === PRIMARY (ACCENT) ===
  static primary = c.primary;
  static primaryHover = c.primaryHover;
  static primaryActive = c.primaryActive;
  static primaryLight = c.primaryLight;

  // === TEXT ===
  static textPrimary = c.textPrimary;
  static textSecondary = c.textSecondary;
  static textTertiary = c.textTertiary;
  static textDisabled = c.textDisabled;
  static textOnPrimary = c.textOnPrimary;
  static textOnDark = c.textOnDark;

  // === STATUS ===
  static success = c.success;
  static successLight = c.successLight;
  static error = c.error;
  static errorLight = c.errorLight;
  static warning = c.warning;
  static warningLight = c.warningLight;

  // === CHART ===
  static chartSuccess = c.chartSuccess;
  static chartSuccessDark = c.chartSuccessDark;
  static chartNeutral = c.chartNeutral;

  // === SPECIAL ===
  static bgCorrect = c.bgCorrect;
  static bgCorrectActive = c.bgCorrectActive;

  // === BORDERS ===
  static border = c.border;
  static borderError = c.borderError;
  static inputErrorBorder = c.inputErrorBorder;

  // === SCROLLBAR ===
  static scrollbarTrack = c.scrollbarTrack;
  static scrollbarThumb = c.scrollbarThumb;
  static scrollbarThumbHover = c.scrollbarThumbHover;

  // === BUTTON ACCENT ===
  static btnAccent = c.btnAccent;
  static btnAccentHover = c.btnAccentHover;
  static btnAccentBorder = c.btnAccentBorder;
  static btnAccentBorderHover = c.btnAccentBorderHover;
  static btnAccentBg = c.btnAccentBg;
  static btnAccentBgHover = c.btnAccentBgHover;
  static btnAccentOutlineHover = c.btnAccentOutlineHover;
  static btnOutlineText = c.btnOutlineText;

  // === LOGO ===
  static logoFilter = c.logoFilter;

  // === MUI ===
  static paletteMode = c.paletteMode as 'light' | 'dark';

  // === HELPERS ===
  static withOpacity = (hex: string, opacity: number): string => {
    // Handle rgba() strings — just return as-is with adjusted opacity
    if (hex.startsWith('rgba(')) {
      const match = hex.match(/rgba\((\d+),\s*(\d+),\s*(\d+)/);
      if (match) return `rgba(${match[1]}, ${match[2]}, ${match[3]}, ${opacity})`;
    }
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  // Dynamic color from backend templates (rgba with ? placeholder for opacity)
  static rgbaOpacityTemplate = (
    template: string | null | undefined,
    opacity: string = '1',
    defaultColor = 'rgba(255, 255, 255, 0.16)',
  ) => ((template?.length || 0) > 0 ? template?.replace('?', opacity) : defaultColor);
}
